import {
  getAdminGroupChatThread,
  listAdminGroupChatMembers,
} from '../../../../api/adminGroupChat';
import {
  listAdminEventChatParticipants,
  listArtistEventChatParticipants,
} from '../../../../api/eventChat';
import { listParts } from '../../../../api/artists';
import {
  listCommonEventCastingProgress,
  listEventCastingInfo,
} from '../../../../api/eventDetails';
import { getArtistGroupChatThread } from '../../../../api/artistChat';

const EMPTY_ARRAY = [];

const toArray = (value) => (Array.isArray(value) ? value : EMPTY_ARRAY);

const resolvePartsList = async ({ partsList }) => {
  if (Array.isArray(partsList) && partsList.length > 0) {
    return partsList;
  }
  try {
    return await listParts();
  } catch (_error) {
    return [];
  }
};

const resolveEventParticipants = async ({ participantsUrl, eventId }) => {
  try {
    return String(participantsUrl || '').includes('/artist/')
      ? await listArtistEventChatParticipants(eventId)
      : await listAdminEventChatParticipants(eventId);
  } catch (_error) {
    return null;
  }
};

const resolveArray = async (loader) => {
  try {
    return toArray(await loader());
  } catch (_error) {
    return [];
  }
};

const resolveGroupThread = async ({ mode, resource, groupThreadId }) => {
  try {
    if (mode === 'artist') {
      return await getArtistGroupChatThread(groupThreadId);
    }
    if (resource === 'members') {
      return await listAdminGroupChatMembers(groupThreadId);
    }
    return await getAdminGroupChatThread(groupThreadId);
  } catch (_error) {
    return null;
  }
};

export const fetchEventMemberModalData = async ({
  apiUrl,
  eventId,
  participantsUrl,
  includeCastingInfo = true,
  includeCastingProgress = true,
  partsList = null,
}) => {
  if (!apiUrl || !eventId || !participantsUrl) {
    return {
      participantSnapshot: null,
      parts: [],
      castingInfo: [],
      progress: [],
    };
  }

  const [participantSnapshot, parts, castingInfo, progress] = await Promise.all([
    resolveEventParticipants({ participantsUrl, eventId }),
    resolvePartsList({ partsList }),
    includeCastingInfo
      ? resolveArray(() => listEventCastingInfo(eventId))
      : Promise.resolve([]),
    includeCastingProgress
      ? resolveArray(() => listCommonEventCastingProgress(eventId))
      : Promise.resolve([]),
  ]);

  return {
    participantSnapshot: participantSnapshot || null,
    parts: toArray(parts),
    castingInfo,
    progress,
  };
};

export const fetchArtistGroupMemberModalData = async ({
  apiUrl,
  groupThreadId,
  partsList = null,
}) => fetchGroupMemberModalData({
  apiUrl,
  groupThreadId,
  partsList,
  mode: 'artist',
  resource: 'thread',
});

export const fetchAdminGroupMemberModalData = async ({
  apiUrl,
  groupThreadId,
  partsList = null,
}) => fetchGroupMemberModalData({
  apiUrl,
  groupThreadId,
  partsList,
  mode: 'admin',
  resource: 'members',
});

export const fetchGroupMemberModalData = async ({
  apiUrl,
  groupThreadId,
  partsList = null,
  mode = 'artist',
  resource = 'thread',
}) => {
  if (!apiUrl || !groupThreadId) {
    return {
      parts: [],
      thread: null,
    };
  }

  const [parts, threadPayload] = await Promise.all([
    resolvePartsList({ partsList }),
    resolveGroupThread({ mode, resource, groupThreadId }),
  ]);

  return {
    parts: toArray(parts),
    thread: threadPayload?.thread || threadPayload || null,
  };
};
